import { create } from "zustand"

type ChapterStatusDialogState = {
  isOpen: boolean
}

type ChapterStatusDialogActions = {
  onOpen: () => void
  onClose: () => void
}

const useChapterStatusDialogV1 = create<
  ChapterStatusDialogState & ChapterStatusDialogActions
>((set) => ({
  isOpen: false,
  onOpen: () => set({ isOpen: true }),
  onClose: () => set({ isOpen: false }),
}))

export default useChapterStatusDialogV1
